import React, { useState, useEffect } from 'react'
import 'antd/lib/style/index.css'
import scCss from './index.module.less'
import { BACKEND_API_URL } from '../../../constants/constants'
import {

  message,
  Row,
  Col,
  MenuProps,
  Menu,
} from 'antd'

import {CreditCardOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import MyCollege from './MyCollege'
import MyBasicInfo from './MyBasicInfo'
import MyPurchasedProjects from './MyPurchasedProjects'
import { sendHttpPostRequest } from '../../../api/http-request'
import { PageHeader } from '../page-header/header'

interface Props {}


const MenuItem = [
  {
    title: '个人信息',
    label: '个人信息',
    key: 'my_info',
    icon: <UserOutlined style={{paddingLeft:2, paddingRight:2,color:'#4f46e5'}} />
  },
  {
    title: '我的机构',
    label: '我的机构',
    key: 'my_college',
    icon:<TeamOutlined  style={{paddingLeft:2, paddingRight:2,color:'#4f46e5'}} />,
  },
  {
    title: '已购项目',
    label: '已购项目',
    key: 'my_purchased_projects',
    icon:<CreditCardOutlined style={{paddingLeft:2, paddingRight:2,color:'#4f46e5'}} />,
  }
 
]


export const UserInfoPage: React.FC<Props> = (props: Props) => {
 
  const [userInfo, setUserInfo] = useState( {} as any) // 完整用户信息

  const [menuSelect, setMenuSelect] = useState('my_info')

  useEffect(() => {
    queryUserInfo()
    return () => {}
  }, [])

  // 调用Confirm框
  const showModal = () => {
    document.getElementById('show-login-modal')?.click()
  }


  /**
   * 获取用户信息
   */
  const queryUserInfo = () => {
    let _data = {}
    const _url = 'account/api/get_user_info/'
    sendHttpPostRequest( 
      _url,
      _data,
      (data) => {
        if (data.code == -100){
          showModal()
        }else if(data.is_ok == true){
          setUserInfo(data.data)

        }else {
          message.error(data?.message)
        }
      })
  }

  const onClick: MenuProps['onClick'] = (e) => {
    setMenuSelect(e.key)
  }

  return (
    <div
    style={{
      width: '100%',
      overflow: 'auto',
    }}
  >

    <PageHeader keys={['-1']} />

    <div className={scCss.scContain}>
      <div className={scCss.contentMain}>
        <div className={scCss.mainLeft}>
          <div className={scCss.userInfo}>
            <Row align={'middle'} justify={'start'}>
              <Col>
                <img
                  width={'40px'}
                  height={'40px'}
                  className={scCss.userAvatar}
                  src={BACKEND_API_URL + userInfo?.avatar}
                  alt=""
                />
              </Col>
              <Col >
                <span
                  className={
                    scCss.userName
                  }
                >
                  {userInfo?.nick_name ?? userInfo?.real_name}
                </span>
  
              </Col>
            </Row>
            <div className={scCss.tip}>{userInfo?.introduction}</div>
          </div>
         
            <Menu
              onClick={onClick}
              style={{ height: 'calc(100% - 157px)' }}
              defaultSelectedKeys={['my_info']}
              selectedKeys={[menuSelect]}
              mode="inline"
              items={MenuItem}
            />
          
        </div>
        <div className={scCss.mainRight}>
          {menuSelect == 'my_info' ? (
            <MyBasicInfo />
          ) : menuSelect == 'my_college' ? (
            <MyCollege />
          ) : menuSelect == 'my_purchased_projects' ? (
            <MyPurchasedProjects />
          ):<MyBasicInfo />}
        </div>
      </div>
    </div>
  </div>
  )
}

export default UserInfoPage
